<template>
  <el-dialog
    :visible.sync="visibleProxy"
    title="Gán gói cho nhiều trường"
    width="680px"
    :close-on-click-modal="false"
    append-to-body
    custom-class="ps-dialog"
  >
    <div class="ps-dialog-intro">
      <div class="ps-dialog-intro__icon"><i class="el-icon-connection" /></div>
      <div>
        <h3>Gán cùng một gói cho nhiều trường</h3>
        <p>Chọn các trường cần gán, sau đó chọn gói đang sử dụng.</p>
      </div>
    </div>

    <div class="ps-bulk-school-summary">
      <span>Trường sẽ được gán</span>
      <strong>{{ selectedSchoolIds.length }} / {{ schools.length }}</strong>
    </div>

    <el-form label-position="top" class="ps-dialog-form">
      <el-form-item label="Chọn trường">
        <div class="ps-bulk-school-picker">
          <el-select
            v-model="schoolToAdd"
            size="small"
            filterable
            clearable
            placeholder="Chọn trường"
            :disabled="!schools.length"
            @change="addSchool"
          >
            <el-option
              v-for="school in schools"
              :key="school.id"
              :value="school.id"
              :label="`${school.id} - ${school.schoolName}`"
              :disabled="selectedSchoolIds.includes(school.id)"
            >
              <span>{{ school.id }}</span> -
              <span>{{ school.schoolName }}</span>
            </el-option>
          </el-select>
          <div v-if="selectedSchools.length" class="ps-bulk-school-tags">
            <el-tag
              v-for="school in selectedSchools"
              :key="school.id"
              class="ps-bulk-school-tag"
              type="primary"
              effect="plain"
              closable
              @close="removeSchool(school.id)"
            >
              {{ school.id }} - {{ school.schoolName }}
            </el-tag>
          </div>
          <span v-else class="ps-bulk-school-picker__empty">
            Chưa có trường được chọn
          </span>
        </div>
      </el-form-item>
    </el-form>

    <el-alert
      v-if="!schools.length"
      class="ps-dialog-alert"
      type="info"
      :closable="false"
      show-icon
      title="Chưa tải được danh sách trường. Vui lòng đóng dialog và thử lại."
    />

    <el-form
      ref="bulkAssignForm"
      :model="form"
      :rules="rules"
      label-position="top"
      class="ps-dialog-form"
    >
      <el-form-item label="Gói áp dụng" prop="packageId">
        <el-select
          v-model="form.packageId"
          class="ps-full-width"
          filterable
          placeholder="Chọn gói đang sử dụng"
          :disabled="!selectedSchoolIds.length"
        >
          <el-option
            v-for="item in packages"
            :key="item.id"
            :label="`${item.code} · ${item.name}`"
            :value="item.id"
          >
            <div class="ps-option-row">
              <span><b>{{ item.code }}</b> · {{ item.name }}</span>
              <span class="ps-option-limit">Số lượng tối đa: {{ item.limit | formatNumber }}</span>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div v-if="selectedPackage" class="ps-assignment-preview">
      <div class="ps-preview-item">
        <span>Giới hạn cơ bản mỗi trường</span>
        <b>{{ selectedPackage.limit | formatNumber }} học sinh</b>
      </div>
      <div class="ps-preview-item">
        <span>Giới hạn hiệu lực ban đầu</span>
        <b>{{ selectedPackage.limit | formatNumber }} học sinh</b>
      </div>
    </div>

    <span slot="footer" class="ps-dialog-footer">
      <el-button @click="visibleProxy = false">Hủy</el-button>
      <el-button
        type="primary"
        :loading="saving"
        :disabled="!selectedSchoolIds.length"
        @click="handleConfirm"
      >
        <i class="el-icon-check" /> Gán cho {{ selectedSchoolIds.length }} trường
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "BulkAssignPackageDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    schools: {
      type: Array,
      default: () => [],
    },
    packages: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: { packageId: "" },
      schoolToAdd: "",
      selectedSchoolIds: [],
      rules: {
        packageId: [{ required: true, message: "Vui lòng chọn gói", trigger: "change" }],
      },
    };
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    selectedSchools() {
      const selectedIds = new Set(this.selectedSchoolIds);
      return this.schools.filter((school) => selectedIds.has(school.id));
    },
    selectedPackage() {
      return this.packages.find((item) => item.id === this.form.packageId);
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.form.packageId = "";
        this.schoolToAdd = "";
        this.selectedSchoolIds = [];
        this.$nextTick(() => {
          if (this.$refs.bulkAssignForm) {
            this.$refs.bulkAssignForm.clearValidate();
          }
        });
      }
    },
  },
  methods: {
    addSchool(schoolId) {
      if (schoolId === undefined || schoolId === null || schoolId === "") return;
      if (!this.selectedSchoolIds.includes(schoolId)) {
        this.selectedSchoolIds.push(schoolId);
      }
      this.schoolToAdd = "";
    },
    removeSchool(schoolId) {
      this.selectedSchoolIds = this.selectedSchoolIds.filter((id) => id !== schoolId);
    },
    handleConfirm() {
      if (!this.selectedSchoolIds.length) {
        this.$message.warning("Vui lòng chọn ít nhất một trường");
        return;
      }
      this.$refs.bulkAssignForm.validate((valid) => {
        if (valid) {
          this.$emit("submit", {
            schoolIds: this.selectedSchoolIds,
            packageId: this.form.packageId,
          });
        }
      });
    },
  },
};
</script>
